export const territories = [
  {
    name: 'Métropole',
    lat: 46.227638,
    lng: 2.213749,
    zoom: 5,
  },
  // {
  //   name: 'Guyane',
  //   lat: 3.9339,
  //   lng: -53.1258,
  //   zoom: 7,
  // },
  {
    name: 'Guadeloupe',
    lat: 16.265,
    lng: -61.551,
    zoom: 9,
  },
  {
    name: 'Réunion',
    lat: -21.115141,
    lng: 55.536384,
    zoom: 9,
  },
  {
    name: 'Martinique',
    lat: 14.641528,
    lng: -61.024174,
    zoom: 9,
  },
  // {
  //   name: 'Mayotte',
  //   lat: -12.8275,
  //   lng: 45.166244,
  //   zoom: 10,
  // },
];
